__turbopack_context__.v({
  "error": "phone-input-module-scss-module__-dfmxG__error",
  "errorMessage": "phone-input-module-scss-module__-dfmxG__errorMessage",
  "input": "phone-input-module-scss-module__-dfmxG__input",
  "input-container": "phone-input-module-scss-module__-dfmxG__input-container",
  "iti__arrow": "phone-input-module-scss-module__-dfmxG__iti__arrow",
  "iti__country": "phone-input-module-scss-module__-dfmxG__iti__country",
  "iti__country-list": "phone-input-module-scss-module__-dfmxG__iti__country-list",
  "iti__flag": "phone-input-module-scss-module__-dfmxG__iti__flag",
  "iti__flag-container": "phone-input-module-scss-module__-dfmxG__iti__flag-container",
  "iti__highlight": "phone-input-module-scss-module__-dfmxG__iti__highlight",
  "iti__search-input": "phone-input-module-scss-module__-dfmxG__iti__search-input",
  "iti__selected-flag": "phone-input-module-scss-module__-dfmxG__iti__selected-flag",
  "label": "phone-input-module-scss-module__-dfmxG__label",
  "root": "phone-input-module-scss-module__-dfmxG__root",
});
